import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { LoginResponse } from '../auth/models/login-response';
import { LoginRequest } from '../auth/models/login-request';
import { User } from 'src/core/models/models';

@Injectable()
export class AuthService {

  public user: User;

  constructor(private http: HttpClient) {}

  public login(loginRequest: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(environment.loginUrl, loginRequest);
  }
}
